import { LogRoute } from "../../types/logRoute";
import Api from "../api";

export default async function apiGetLogRoute(id: string) {
  return await Api.get<LogRoute>({
    input: `/api/v1/log-route/${id}`,
  });
}
